import React from 'react'
import PropTypes from "prop-types"
import { bem } from '../../helpers'

const Cell = (props) => {
  const {children, cellType, className} = props
  return (
    <>
      {cellType === "header" && <th className={bem("table", "head__cell", [], className)}> {children} </th>}
      {cellType === "body" && <td className={bem("table", "body__cell", [], className)}> {children} </td>}
    </>
  )
}

Cell.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.number]),
  cellType: PropTypes.oneOf(["header", "body"]),
  className: PropTypes.string
}

export default Cell
